<template>
  <modal
    name="grain-limit-warning-modal"
    :scrollable="true"
    :max-width="600"
    :width="450"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="info-modal">
      <div class="info-modal__header">
        <h1 class="info-modal__title">{{ title }}</h1>
      </div>
      <div class="info-modal__content">
        <ul v-if="messages.length > 0" style="text-align: left; padding-left: 20px;">
          <li v-for="(message, index) in messages" :key="index" style="margin-bottom: 10px;">
            {{ message }}
          </li>
        </ul>
      </div>
      <div class="info-modal__btns" style="text-align: right;">
        <span
          class="btn"
          @click="hideModal"
        >
          Entendido
        </span>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      messages: [],
    };
  },
  methods: {
    beforeOpen(event) {
      if (event.params) {
        this.title = event.params.title || 'Advertencia';
        this.messages = event.params.messages || [];
      }
    },
    hideModal() {
      this.$modal.hide('grain-limit-warning-modal');
    },
  },
};
</script>
